import { isUndefined } from '@aloft/toolkit-shared';
import { createSelector } from '@reduxjs/toolkit';

import { selectDepreciation } from './depreciationSelectors.ts';
import { selectCostNew } from './selectCostNew.ts';

export const selectDepreciatedCostOfImprovements = createSelector(
  [selectCostNew, selectDepreciation],
  (costNew, depreciation) => {
    if (isUndefined(costNew)) return undefined;
    if (isUndefined(depreciation)) return costNew;

    return costNew.add(depreciation);
  },
);

export const selectDepreciatedCostOfImprovementsDisplay = createSelector(
  [selectDepreciatedCostOfImprovements],
  (depreciatedCost) => depreciatedCost?.toString(true),
);
